import { ArrowBack } from "@mui/icons-material"
import { Button, Typography, useMediaQuery } from "@mui/material"
import { Outlet, useNavigate } from "react-router-dom"
import ROUTE_PATHS from "src/routes/route-path"
import { CenteredBox, Stack } from "src/shared/components"

const PosLayout = () => {
  const navigate = useNavigate()
  const minWidth = useMediaQuery("(min-width: 1024px)")
  if (!minWidth)
    return (
      <CenteredBox sx={{ height: "100%", width: "100%" }}>
        <Typography variant="h3" textAlign={"center"}>
          Please use a larger screen
        </Typography>
        <Typography variant="body1" textAlign={"center"}>
          Min Allowed Width 1024
        </Typography>
        <Button
          onClick={() => navigate(ROUTE_PATHS.DASHBOARD)}
          startIcon={<ArrowBack />}
          variant="outlined"
          size="small"
        >
          Dashboard
        </Button>
      </CenteredBox>
    )
  return (
    <Stack
      id="main-layout"
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100vh",
        background: (theme) => theme.palette.secondary.main
      }}
    >
      <Outlet />
    </Stack>
  )
}

export default PosLayout
